
import React from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import {noticeStyles, noticeTones} from './boxChampNoticeStyles';

// GROOV-4994 silent-failure fix (defect 2): CalculateBoxChampBoxes can fail (network,
// server error) and the packer previously learned nothing — the screen just fell back to
// the ordinary (fully-functional) unguided list with no indication the box plan never
// loaded. This banner is the "something went wrong" signal that was missing; it does not
// change the fallback rendering, which is deliberate and correct on its own.
export default function BoxChampPlanErrorNotice({message, onDismiss, onRetry}) {
  if (!message) return null;

  return (
    <View
      testID="boxchamp-plan-error-notice"
      style={[noticeStyles.banner, {backgroundColor: noticeTones.danger.background}]}>
      <View style={{flexDirection: 'row', alignItems: 'center'}}>
        <Text
          testID="boxchamp-plan-error-text"
          style={[noticeStyles.text, {color: noticeTones.danger.text, flex: 1}]}>
          {message}
        </Text>
        {!!onRetry && (
          <TouchableOpacity
            testID="boxchamp-plan-error-retry"
            onPress={onRetry}
            style={{paddingHorizontal: 8, paddingVertical: 2}}>
            <Text
              style={[
                noticeStyles.text,
                {color: noticeTones.danger.text, textDecorationLine: 'underline'},
              ]}>
              Retry
            </Text>
          </TouchableOpacity>
        )}
        {!!onDismiss && (
          <TouchableOpacity
            testID="boxchamp-plan-error-dismiss"
            onPress={onDismiss}
            style={{paddingHorizontal: 8, paddingVertical: 2}}>
            <Text style={[noticeStyles.text, {color: noticeTones.danger.text}]}>✕</Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
}
